import React, { useMemo } from "react";
import { useTranslation } from "react-i18next";
import { useAuth } from "../../hooks/auth";
import Select from "../Form/Select";

type Props = any;

const INVOICE_TYPES_LETTERS = ['E', 'A', 'G', 'I', 'M', 'P', 'R', 'C', 'T'];

const SelectInvoiceType: React.FC<Props> = ({ name, label, style, control, disabled }) => {
  const { isCampoLargo, isMopar } = useAuth()
  const isCampoLargoUser = isCampoLargo();
  const isMoparUser = isMopar();
  const { t: it } = useTranslation(isMoparUser ? "MvmInvoiceMopar" : "MvmInvoice")

  const invoiceTypes = useMemo(() => {
    let invoiceTypesTMP = INVOICE_TYPES_LETTERS;

    if (!isCampoLargoUser && !isMoparUser)
      invoiceTypesTMP = INVOICE_TYPES_LETTERS.filter((el => el !== 'C'))

    return invoiceTypesTMP.map((x) => ({ code: x, label: it("invoiceType_" + x) }))
  }, [isCampoLargoUser, isMoparUser, it]);

  return (
    <Select
      label={label} 
      name={name}
      control={control} 
      options={invoiceTypes}
      disabled={disabled}
      style={style ? style : {width: '100%'}}/>

  )
}

export default SelectInvoiceType;